module.exports = __webpack_public_path__ + "static/img/picture17.1bb6b99b.png";